module.exports = __webpack_public_path__ + "static/peopleware-525368b8bb64f94ce44267aef2cee493.jpg";